
export const labels = {
  UNLOCK_PAYMENTS: "Complete your KYC and start accepting payments",
  START_ACCEPTING_PAYMENTS: "Complete your account activation and start accepting payments.",
  COMPLETE_PROFILE: "Resume Journey",
  BEGIN_JOURNEY: 'Start KYC',
  TEST_IN_TEST_ENV: "Try payments in the test environment",
  ACCESS_TEST_CREDENIALS: "View test credentials",
  API_DOC: "View API documentation",
  INFO_VALIDATION_FAILED: "Info Verification Failed",
  MERCHANT_REJECTED: "Your plural account verification is rejected!",
  RE_SUBMIT_INFORMATION: 'Restart your journey',
  SOME_DETAILS_CANNOT_BE_VERIFIED: 'Some of your information could not be verified. Please re-submit to verify account.',
  REJECTED_INFO: 'Sorry, we could not activate your plural account. Please contact our customer support for further assistance.',
  WE_ARE_REVIEWING: 'Your account is under review.',
  YOU_CAN_START: 'We will notify you when your account has been approved and activated',
  UPI_CARD_ACTIVE: '<b>UPI</b> and <b>Card</b> payment methods are active. ',
  LEARN_ABOUT_PLURAL: 'Explore our test environments and learn more about plural',
  CHECK_STATUS: 'check activation status',
  ACCOUNT_VERIFIED: "You're Account is Verified",
  YOU_CAN_NOW_ACCEPT_PAYMENT: 'You can now start to accept payments on activated payment modes.',
  ISSUE_IN_ACTIVATING: 'There is an issue activating your account!',
  RESOLVE_ISSUE:'We could not activate your account as there was some issue in your business details, website details and documents to verify your business. Please resolve all issues to activate your account.',
  LEARN_MORE: 'Learn More',
};

export const PROFILE_STATUS = {
  PENDING: 'PENDING',
  SOFT_REJECTED: 'SOFT_REJECTED',
  FAILURE: 'FAILED',
  SUCCESS: 'APPROVED',
};

export const CURRENT_STEP_MAPPING = {
  MDR_ACCEPTANCE: 'MDR_ACCEPTANCE',
  PAN_GST_DETAILS : 'PAN_VERIFICATION', 
  KYC_VERIFICATION : 'KYC_VERIFICATION',
  BUSINESS_DETAILS : 'BUSINESS_DETAILS',
  VIDEO_KYC_VERIFICATION: 'VIDEO_KYC_VERIFICATION',
  // DOCUMENTS_UPLOAD : 'DOCUMENTS_UPLOAD',
  BANK_DETAILS: 'BANK_DETAILS',
  REVIEW_DETAILS: 'REVIEW_DETAILS',
  DOCUMENTS_UPLOAD: 'SOLE_PROP_DOCUMENTS_UPLOAD',
  UPLOAD_COMPANY_DOCUMENTS: 'UPLOAD_COMPANY_DOCUMENTS',
  KYC_AGREEMENT_SIGN: 'KYC_AGREEMENT_SIGN',
};

export const FLOW_CIN_LLP_STEP_MAPPING = {
  MDR_ACCEPTANCE: 'MDR_ACCEPTANCE',
  PAN_GST_DETAILS : 'PAN_VERIFICATION', 
  BANK_DETAILS: 'BANK_DETAILS',
  DOCUMENTS_UPLOAD : 'DOCUMENTS_UPLOAD',
  REVIEW_DETAILS: 'REVIEW_DETAILS',
  KYC_AGREEMENT_SIGN : 'KYC_AGREEMENT_SIGN',
};

export const addSelectProductsToFlow = () => {
  return;
  if (!CURRENT_STEP_MAPPING['CHOOSE_PRODUCTS']) {
    CURRENT_STEP_MAPPING['CHOOSE_PRODUCTS'] = 'SELECT_PRODUCTS';
  }
  
  if (!CURRENT_STEP_MAPPING['LEAD_GENERATION']) {
    CURRENT_STEP_MAPPING['LEAD_GENERATION'] = 'SELECT_PRODUCTS';
  }
  
  if (!FLOW_CIN_LLP_STEP_MAPPING['CHOOSE_PRODUCTS']) {
    FLOW_CIN_LLP_STEP_MAPPING['CHOOSE_PRODUCTS'] = 'SELECT_PRODUCTS';
  }
  
  if (!FLOW_CIN_LLP_STEP_MAPPING['LEAD_GENERATION']) {
    FLOW_CIN_LLP_STEP_MAPPING['LEAD_GENERATION'] = 'SELECT_PRODUCTS';
  }
  
};

export const addBusinessVerificationToFlow = () => {
  if (!CURRENT_STEP_MAPPING['BUSINESS_DETAILS']) {
    CURRENT_STEP_MAPPING['BUSINESS_DETAILS'] = 'BUSINESS_DETAILS';
  }
};
